import * as React from 'react';
import {authorize, IWithRouterProps, withRouter} from "@athena-portal/components";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {ClaimSubmissionPanel} from "../../../../../components/claims/ClaimSubmissionPanel";
import {HomeOnlineClaimRequest} from "@falcon/services";
import { getSessionStorage, scrollToTop } from "../../../../../CommonFunctions";
import {AllianzOnlineBadge} from "../../../../../components/AllianzOnlineBadge";

interface IPageParams {
    policyNumber: string;
    [key: string]: string | undefined;
}

interface IState {
    onlineClaimRequest: HomeOnlineClaimRequest;
}

@authorize
export class HomeClaimSubmittedPagePlain extends React.Component<IWithRouterProps<IPageParams>, IState> {

    private pluginTemplates = new PluginTemplates();

    constructor(props: IWithRouterProps<IPageParams>) {
        super(props);

        const claimRequest: HomeOnlineClaimRequest = getSessionStorage("homeOnlineClaimRequest");

        this.state = {
            onlineClaimRequest: claimRequest
        }
    }

    public componentDidMount(): void {
        scrollToTop();
    }

    public render(): React.ReactNode {
        const backLinkUrl: string = `/dashboard/annualHome/${this.props.params.policyNumber}`;

        return (
            <>
                <FalconHeader/>
                <div className="page-contents text-center">
                    <AllianzOnlineBadge/>
                    {this.pluginTemplates.renderBackLink("Back", true, backLinkUrl)}
                    <ClaimSubmissionPanel onlineClaimRequest={this.state.onlineClaimRequest} showUrgentClaimSection={false} />
                    {this.pluginTemplates.renderBackLink("Back", false, backLinkUrl)}
                </div>
                <FalconFooter/>
            </>
        )
    }
}

export const HomeClaimSubmittedPage = withRouter<{}, IPageParams>(HomeClaimSubmittedPagePlain)
